import React, { useState } from "react";
import { sendUpgradeRequest } from "../../../queries/consumer/upgrade";

const UpgradePage = ({ currentUser, toast }) => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const handleUpgradeButton = async () => {
    const response = await sendUpgradeRequest(
      currentUser.fullName,
      currentUser.email,
      currentUser.organization.legal_name
    ).catch(() => {
      toast.error("Something went wrong please try again later  ");
    });
    if (response === 204) {
      toast.success("You successfully send your upgrade request");
      setShowSuccessMessage(true);
    }
  };

  return (
    <div className="container mw-520">
      <div className="box-md p-3 p-sm-4 p-md-5">
        <h4 className="mb-4">Upgrade account</h4>
        {!showSuccessMessage ? (
          <>
            <p>
              Launch your product! Get access to all our live platforms, pay as
              you scale!
            </p>

            <h6>Product:</h6>
            <ul className="checklist checklist-check">
              <li>
                Access to production data from the banks we have direct access
                to
              </li>
              <li>Access to production scoring</li>
              <li>
                Access to continuous creditworthiness and affordability
                monitoring
              </li>
            </ul>

            <h6 className="mt-4">Services:</h6>
            <ul className="checklist checklist-check">
              <li>Integration support</li>
              <li>Premium support</li>
              <li>Account management</li>
            </ul>

            <div className="mt-45">
              <button
                className="btn btn-sm btn-main"
                onClick={() => handleUpgradeButton()}
              >
                Upgrade my account
              </button>
            </div>
          </>
        ) : (
          <>
            <p>We have send your request for upgrade to our sales team!!</p>
          </>
        )}
      </div>
    </div>
  );
};

UpgradePage.propTypes = {};

export default UpgradePage;
